import { ComponentView } from "binder";
import { LoadingViewModel } from "./loading-viewModel"

export class LoadingView extends ComponentView<LoadingViewModel>{
    GetViewUniqueId(): string {
        return "V-C55A074A-1D28-4395-B6CC-CC0363CEFB14"
    }
    loadHtml(): string {
        let element = require('./loading.html').default;
        let style = require('./loading.less');
        return element;
    }
    constructor() {
       super();
    }
    onRenderCompleted(){
        this._childrenPlaceholder = this.firstlevelElement.querySelector('.childrenPlaceHolder');
        // this._overlay = this.firstlevelElement.querySelector('.overlay');
    }
    private _childrenPlaceholder:Element;
    private _overlay:HTMLElement;
    
    append(...nodes: (Node | string)[]): void{
        this._childrenPlaceholder.append(...nodes);
    }

    public set isloading(v: boolean) {
        this._isloading = v;
        // if(v)
        //     this._overlay.style.display="block";
        // else 
        //     this._overlay.style.display="none";
    } public get isloading(): boolean { return this._isloading;} private _isloading: boolean;
}
